<script>
export default {
    name: 'PermsUpdateForm',
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            }
    },
    data() {
        return {}
    },
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <form-wrapper :validator="validator ">
        <div>
            <form-summary/>
        </div>
        <form-group name="name" label="Name">
            <b-form-input
                v-model="form.name"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="codename" label="Codename">
            <b-form-input
                v-model="form.codename"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="description" label="Description">
            <div>
                <b-form-textarea
                    id="textarea"
                    v-model="form.description"
                    placeholder="Description"
                ></b-form-textarea>
            </div>
        </form-group>    
        </form-wrapper>
    </b-form>
</template>